var initializeSubmenuPosition;

(function($) {

    initializeSubmenuPosition = function() {
        // get main navigations offset right
        var offsetMain = $('.navbar-nav').offset();
        var widthMain = $('.navbar-nav').outerWidth();
        var offsetMainRight = ($(window).width() - (offsetMain.left + widthMain));

        // remove padding from parent container
        $('.subnav-container').css({"padding": 0});
        $('.subnav-container > .container').css({"padding": 0});

        $('.sub-nav').each(function() {
            // find parent navigations offset right
            var currentSubnav = $(this);
            var parent = currentSubnav.closest('.collapse-submenu');
            var parentContainer = currentSubnav.closest('.subnav-container');
            var offsetParent = parent.offset();
            var widthParent = parent.outerWidth();
            var offsetParentRight = ($(window).width() - (offsetParent.left + widthParent));
            var centerParent = offsetParentRight + (widthParent/2);

            var rightPosition = centerParent - offsetMainRight - currentSubnav.width()/2 + offsetMainRight;

            var additionalLength = currentSubnav.has("div.subnav-container").length ? 123 : 0;

            if(additionalLength == 0) {
                parent.addClass('no-subitems');
            }

            // set offset for subnav
            parentContainer.css({
                "right": rightPosition + additionalLength,
                "left": "auto"
            });
            // write position into data attribute
            parentContainer.data("position-right", rightPosition);
        });

        // var initialPosition;
        // $('.sub-nav .collapse-submenu').hover(function() {
            // initialPosition = $(this).closest('.subnav-container').data("position-right");
            // $(this).closest('.subnav-container').css({"right": initialPosition + 123});
        // }, function() {
            // $(this).closest('.subnav-container').css({"right": initialPosition});
        // });
    }

})(jQuery);